import { get } from 'lodash'
import { required } from 'utils/validation'

const validate = values => {
  let errors = {}

  errors = {
    countryId: required(get(values, 'countryId')),
    organizationId: required(get(values, 'organizationId')),
  }

  return errors
}

export default validate
